/**
 * SA-1165: janela máxima para considerar um login como signup novo.
 *
 * No OAuth do Google, o signup e o primeiro login acontecem no mesmo callback,
 * então uma conta cujo `createdAt` é "agora" indica um signup; logins
 * recorrentes têm `createdAt` antigo. 5 min é folgado o bastante para o
 * roundtrip do OAuth + `/user/me` sem incluir logins recorrentes.
 */
export const GOOGLE_SIGNUP_MAX_AGE_MS = 5 * 60 * 1000;

/**
 * Heurística para diferenciar um signup recém-criado de um login recorrente a
 * partir do `createdAt` do usuário. Retorna `false` para valores ausentes,
 * inválidos ou fora da janela.
 *
 * A janela é considerada em módulo (`|now - createdAt| <= maxAgeMs`): um
 * `createdAt` levemente no futuro por clock skew entre o relógio do cliente e o
 * do servidor ainda conta como signup recente, desde que dentro da janela — do
 * contrário um signup real poderia não disparar o evento. Futuro além da janela
 * continua sendo descartado.
 */
export function isRecentSignup(
  createdAt: string | Date | null | undefined,
  maxAgeMs: number = GOOGLE_SIGNUP_MAX_AGE_MS,
  nowMs: number = Date.now()
): boolean {
  if (!createdAt) return false;

  const createdMs = new Date(createdAt).getTime();
  if (Number.isNaN(createdMs)) return false;

  const ageMs = nowMs - createdMs;
  return Math.abs(ageMs) <= maxAgeMs;
}
